module.exports = __webpack_public_path__ + "static/lframe-pay-it-faster-f0d41c4cac5d9db734cb1b66f0649f80.png";